module.exports = __webpack_public_path__ + "static/demo-blurred-8c6658c22440fe78c0034b220d0b3441.mp4";